<template>
  <div class="form-container">
    <div class="el-descriptions-title margin-b20">生产能力保障审查</div>
    <div v-for="item in tableData" :key="item.abilityId" class="margin-b10">
      <div class="one-level">
        <span>一级指标：{{ item.ability }}</span>
        <span>分值：{{ item.score }}分</span>
      </div>
      <eTableList
        :table-data="item.list"
        :table-label="tableLabel"
        :index-show="false"
        :right-span-method="objectSpanMethod"
      >
        <template #review="{ scope: { row } }">
          <el-input v-model="row.review" :max-length="1000" type="text" />
        </template>
        <template #grade="{ scope: { row } }">
          <el-input v-model="row.grade" type="text" @input="onInput" />
        </template>
        <!-- <template #advice="{ scope: { row } }">
          <el-input v-model="row.advice" :max-length="1000" type="text" />
        </template> -->
        <template #advice="{ scope: { row } }">
          <!-- <el-input v-model="row.advice" :max-length="1000" type="text" /> -->
          <eui-btn type="link" @click="uploadClick(row)">上传</eui-btn>
          <eui-btn type="link">查看</eui-btn>
        </template>
      </eTableList>
    </div>

    <Upload :dialog-visible.sync="dialogVisible"></Upload>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/ESorganization';
import eTableList from '@/modules/projectA/components/common/e-table-list-merge';
import Upload from './upload.vue';

export default {
  name: 'CapabilityReview',
  components: { eTableList, Upload },
  data() {
    return {
      tableData: [],
      tableLabel: [
        {
          label: '二级指标',
          param: 'parentAbility',
          align: 'center',
          width: 130,
        },
        { label: '分值', param: 'parentScore', align: 'center', width: 80 },
        {
          label: '三级指标',
          param: 'ability',
          align: 'center',
          minWidth: 120,
          tooltip: true,
        },
        { label: '分值', param: 'score', align: 'center', width: 80 },
        {
          label: '评审标准',
          param: 'standard',
          align: 'center',
          minWidth: 120,
          tooltip: true,
        },
        {
          label: '备注',
          param: 'remark',
          align: 'center',
          minWidth: 120,
          tooltip: true,
        },
        { label: '评审情况', slot: 'review', align: 'center', minWidth: 120 },
        { label: '得分', slot: 'grade', align: 'center', width: 100 },
        /* { label: '改进建议', slot: 'advice', align: 'center', minWidth: 120 }, */
        { label: '过程资料', slot: 'advice', align: 'center', minWidth: 120 },
      ],
      dialogVisible: false,
    };
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.$emit('getTableData', newVal);
      },
      deep: true,
    },
  },
  created() {
    this.getData();
  },
  methods: {
    uploadClick(row) {
      console.log(row);
      this.dialogVisible = true;
    },
    onInput() {
      let score = 0;
      this.tableData.forEach((item) => {
        item.list.forEach((item2) => {
          score += Number(item2.grade || '0');
        });
      });
      this.$emit('setScore', score);
    },
    async getData() {
      const { evaluationItemId, applyId, id } = this.$route.query;
      const res = await Api.structSiteReview({
        applyId,
        evaluationItemId,
        applyItemPriceId: id,
      });
      if (res.code === '200') {
        this.tableData = this.listToTree(res.data.evaluationProduceAbilityList).map((item) => {
          let list = [];
          item.children?.forEach((item2) => {
            if (item2.children?.length) {
              item2.children[0].span = item2.children.length;
              list = list.concat(item2.children);
            }
          });
          return {
            ...item,
            list,
          };
        });
        this.onInput();
      }
    },
    listToTree(data) {
      // * 先生成parent建立父子关系
      const obj = {};
      data.forEach((item) => {
        obj[item.abilityId] = item;
      });
      const parentList = [];
      data.forEach((item) => {
        const parent = obj[item.abilityParentId];
        if (parent) {
          // * 当前项有父节点
          parent.children = parent.children || [];
          item.parentAbility = parent.ability;
          item.parentScore = parent.score;
          // item.grade = item.grade || '';
          parent.children.push(item);
        } else {
          // * 当前项没有父节点 -> 顶层
          if (!item.abilityParentId) {
            parentList.push(item);
          }
        }
      });
      return parentList;
    },
    /**
     * 合并单元格
     * @param row
     * @param columnIndex
     * @returns {{colspan: number, rowspan: *}|{colspan: number, rowspan: number}}
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex < 2) {
        return {
          rowspan: row.span,
          colspan: 1,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.one-level {
  padding-left: 20px;
  line-height: 40px;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, 'microsoft yahei', arial, STHeiTi, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  border: 1px solid #ebeef5;
  background: #f5f5f5;
  border-bottom: 0;
  color: #333333;

  > span:nth-child(1) {
    margin-right: 20px;
  }
}

.form-container {
  padding-bottom: 10px;
}
</style>
